import { useQuery,useQueries } from "@tanstack/react-query";
import fetchReportData from "api/report";
import { queryKeys } from "react-query/constant";
import {HypoInfoApi} from "../api/hypo";

const useReport = (patientId) => {
  return useQuery([queryKeys.reportData, patientId], () => fetchReportData(patientId), {
    onError: (error) => console.log(error)
  });
};
export const useReview = (patientId, chosen) => {
  const fetchData = HypoInfoApi();
  return useQueries({
    queries: [
      {
        queryKey: [queryKeys.reportData, patientId],
        queryFn: () => fetchReportData(patientId),
      },
      {
        queryKey:[queryKeys.hypoInfo, patientId, chosen],
        queryFn: () => fetchData(patientId,chosen),
      }
    ]
  })

}
const useGet365DayReportData = (patientId, chosen) => {
  return useQuery([queryKeys.reportData, patientId, chosen], () => fetchReportData(patientId, chosen), {
    enabled: +chosen === 365,
    onError: (error) => console.log(error)
  });
};

export { useReport, useGet365DayReportData };